import { createSelector } from "reselect";

const selectFaculty = (state) => state.faculties;

export const facultiesLoading = createSelector(
  [selectFaculty],
  (faculty) => faculty.isLoading
);

export const selectIsCreatingFaculty = createSelector(
  [selectFaculty],
  (faculty) => faculty.isCreatingFaculty
);
export const selectIsEditingFaculty = createSelector(
  [selectFaculty],
  (faculty) => faculty.isEditingFaculty
);
export const selectIsDeletingFaculty = createSelector(
  [selectFaculty],
  (faculty) => faculty.isDeletingFaculty
);
export const selectFaculties = createSelector(
  [selectFaculty],
  (faculty) => faculty.faculties
);
